module.exports = __webpack_public_path__ + "img/fc00556.jpg";